import React from 'react';
import ProtectedRoute from '../../controllers/ProtectedRoute';
import {
  DesksConfigsParamsProvider,
  DesksConfigsProvider,
} from './services/desksConfigs';
import { FormControllerProvider } from '../../../../helpers/formManager';
import SetupLayout from '../../shared/ui/SetupLayout';
import Header from './presenters/Header';
import Body from './presenters/Body';
import FetchInitDataWrapper from './presenters/FetchInitDataWrapper';
import { FormValuesProvider, useFormValues } from './services/setFormValues';
import { TimeIntervalsProvider } from '../../services/timeIntervals';
import { fieldNames } from '../../shared/configs/acceptanceForm';
import styles from './index.module.scss';

const ChangeDesksSettingsPage = ({ className }) => {
  return (
    <ProtectedRoute>
      <DesksConfigsParamsProvider>
        <FetchInitDataWrapper className={className}>
          <TimeIntervalsProvider>
            <DesksConfigsProvider>
              <FormValuesProvider>
                <FormProvider>
                  <SetupLayout
                    className={styles.layout}
                    header={<Header />}
                    body={<Body />}
                  />
                </FormProvider>
              </FormValuesProvider>
            </DesksConfigsProvider>
          </TimeIntervalsProvider>
        </FetchInitDataWrapper>
      </DesksConfigsParamsProvider>
    </ProtectedRoute>
  );
};

export default ChangeDesksSettingsPage;

function FormProvider({ children }) {
  const values = useFormValues();

  const configId = values?.[fieldNames.main.configId];

  return (
    <FormControllerProvider key={configId} options={{ defaultValues: values }}>
      {children}
    </FormControllerProvider>
  );
}
